const STORAGE_KEY = "gada_auth";

export function getAuthSession() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (_error) {
    return null;
  }
}

export function storeAuthSession(session) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(session));
}

export function clearAuthSession() {
  localStorage.removeItem(STORAGE_KEY);
}

export function isAuthenticated() {
  const session = getAuthSession();
  return Boolean(session?.token);
}

export function getCurrentRole() {
  const session = getAuthSession();
  if (!session) {
    return null;
  }

  return session.roleKey || (typeof session.role === "string" ? session.role.toLowerCase() : null);
}

export function updateAuthSession(patch) {
  const current = getAuthSession() || {};
  storeAuthSession({
    ...current,
    ...patch,
  });
}
